export default "__VITE_PUBLIC_ASSET__9f12f8a7__"